import { HARVESTING_PLAN_TYPE_ID, LOGISTIC_PLAN_TYPE_ID, PLANTING_PLAN_TYPE_ID } from "./index";

export const harvestingColumns = [
    { key: "lot", label: "Lot #", default: true },
    { key: "cropName", label: "Crop" },
    { key: "growersName", label: "Grower's Name", default: true },
    { key: "grower", label: "Grower", default: true },
    { key: "targetEquipmentGroupName", label: "Truck #", default: true },
    { key: "contract", label: "Contract/p.o #", default: true },
    { key: "offloadStorageLocationName", label: "Storage #", default: true },
    { key: "pipe", label: "Pipe #", default: true },
    { key: "fieldGeoShapeName", label: "Field #", default: true },
    { key: "ref", label: "Ref #", default: true },
    { key: "loadGrossWeight", label: "Gross", type: "weight", default: true },
    { key: "lightWeight", label: "Light", type: "weight", default: true },
    { key: "tareWeight", label: "Tare", type: "weight", default: true },
    { key: "loadCapacity", label: "Net", type: "weight", default: true },
    { key: "operatorName", label: "Driver", default: true },
    { key: "modifiedByNameFromQueue", label: "Weigher", default: true },
    { key: "approvedBy", label: "Unloader", default: true },
    { key: "sourceOperatorname", label: "Digger", default: true },    
    { key: "crewName", label: "Crew" },    
    { key: "customerName", label: "Customer Name" },   
    { key: "variety", label: "Variety" },
    { key: "sourceEquipmentGroupName", label: "Source EG" },    
    { key: "transloadGeoShapeName", label: "Transload Site" },
    { key: "transportEquipmentGroupName", label: "Transport EG" },
    { key: "transportOperatorName", label: "Transport EG Operator" },
    { key: "offloadGeoShapeName", label: "Offload Site" },    
    { key: "comments", label: "Comments", default: true }      
    /* { key: "load_date", label: "Load Time" },
    { key: "load_seconds", label: "Duration" },
    { key: "approved", label: "Approved" },
    { key: "approved_date", label: "Approved Date" },
    { key: "load_time", label: "Load Time" },
    { key: "actual_duration", label: "Duration" },
    { key: "division", label: "Division" },
    { key: "area", label: "Area" },
    { key: "unit", label: "Unit" },
    { key: "createdByName", label: "Created By" },
    { key: "round_trip_load_time_format", label: "Roundtrip Load Time" },
    { key: "target_equipment_vendor_name", label: "Vendor" } */
];

export const plantingColumns = [
    { key: "lot", label: "Lot #", default: true },
    { key: "cropName", label: "Crop" },    
    { key: "growersName", label: "Grower's Name", default: true },
    { key: "grower", label: "Grower", default: true },
    { key: "targetEquipmentGroupName", label: "Truck #", default: true },
    { key: "contract", label: "Contract/p.o #", default: true },
    { key: "offloadStorageLocationName", label: "Storage #", default: true },
    { key: "pipe", label: "Pipe #", default: true },
    { key: "fieldGeoShapeName", label: "Field #", default: true },
    { key: "ref", label: "Ref #", default: true },
    { key: "loadGrossWeight", label: "Gross", type: "weight", default: true },
    { key: "lightWeight", label: "Light", type: "weight", default: true },
    { key: "tareWeight", label: "Tare", type: "weight", default: true },
    { key: "loadCapacity", label: "Net", type: "weight", default: true },
    { key: "operatorName", label: "Driver", default: true },
    { key: "modifiedByNameFromQueue", label: "Weigher", default: true },
    { key: "approvedBy", label: "Unloader", default: true },
    { key: "sourceOperatorname", label: "Source Operator Name", default: true },
    { key: "crewName", label: "Crew" },    
    { key: "customerName", label: "Customer Name" },    
    { key: "sourceEquipmentGroupName", label: "Source EG" },     
    { key: "transloadGeoShapeName", label: "Transload Site" },
    { key: "transportEquipmentGroupName", label: "Transport EG" },
    { key: "transportOperatorName", label: "Transport EG Operator" },
    { key: "offloadGeoShapeName", label: "Offload Site" },
    { key: "scaleTicket", label: "Scale Ticket", default: true },
    { key: "comments", label: "Comments", default: true }
];

export const logisticsColumns = [
    { key: "lot", label: "Lot #", default: true },
    { key: "growersName", label: "Grower's Name", default: true },
    { key: "grower", label: "Grower", default: true },
    { key: "targetEquipmentGroupName", label: "Truck #", default: true },
    { key: "contract", label: "Contract/p.o #", default: true },
    { key: "sourceOffloadStorageLocationName", label: "Source Storage #", default: true },
    { key: "sourcePipe", label: "Source Pipe #", default: true },
    { key: "offloadStorageLocationName", label: "Storage #", default: true },
    { key: "pipe", label: "Pipe #", default: true },
    { key: "ref", label: "Ref #", default: true },
    { key: "loadGrossWeight", label: "Gross", type: "weight", default: true },
    { key: "lightWeight", label: "Light", type: "weight", default: true },
    { key: "tareWeight", label: "Tare", type: "weight", default: true },
    { key: "loadCapacity", label: "Net", type: "weight", default: true },
    { key: "operatorName", label: "Driver", default: true },    
    { key: "modifiedByNameFromQueue", label: "Weigher", default: true },
    { key: "approvedBy", label: "Unloader", default: true },
    { key: "sourceOperatorname", label: "Source Operator Name", default: true },
    { key: "crewName", label: "Crew" },
    { key: "customerName", label: "Customer Name" },
    { key: "cropName", label: "Crop" },
    { key: "sourceEquipmentGroupName", label: "Source EG" },  
    { key: "transloadGeoShapeName", label: "Transload Site" },
    { key: "transportEquipmentGroupName", label: "Transport EG" },
    { key: "transportOperatorName", label: "Transport EG Operator" },
    { key: "sourceOffloadGeoShapeName", label: "Source Offload Site" },
    { key: "offloadGeoShapeName", label: "Offload Site" },
    { key: "comments", label: "Comments", default: true }
];

export const getLoadColumns = (params) => {
    const { planTypeId, printLoadTicket, customSettings, isFilterColumns, loadParamsColumns } = params;

    let columns = [];
    let loadTicketEnabled = false;
    let userSelected = [];
    let ticketConfig = {};

    if (isFilterColumns && customSettings && customSettings.hasOwnProperty('print_load_ticket')) {
        ticketConfig = customSettings.print_load_ticket;
    }

    switch (planTypeId) {
        case PLANTING_PLAN_TYPE_ID: {
            columns = [...plantingColumns, ...loadParamsColumns];
            loadTicketEnabled = printLoadTicket['planting_visible'] || false;
            if (isFilterColumns && ticketConfig.planting && ticketConfig.planting.selected_columns) {
                userSelected = ticketConfig.planting.selected_columns;
            }
            break;
        }
        case HARVESTING_PLAN_TYPE_ID: {
            columns = [...harvestingColumns, ...loadParamsColumns];
            loadTicketEnabled = printLoadTicket['harvesting_visible'] || false;
            if (isFilterColumns && ticketConfig.harvesting && ticketConfig.harvesting.selected_columns) {
                userSelected = ticketConfig.harvesting.selected_columns;
            }
            break;
        }
        case LOGISTIC_PLAN_TYPE_ID: {
            columns = [...logisticsColumns, ...loadParamsColumns];
            loadTicketEnabled = printLoadTicket['logistics_visible'] || false;
            if (isFilterColumns && ticketConfig.logistics && ticketConfig.logistics.selected_columns) {
                userSelected = ticketConfig.logistics.selected_columns;
            }
            break;
        }
        default:
            columns = harvestingColumns;
            loadTicketEnabled = printLoadTicket['harvesting_visible'] || false;
            if (isFilterColumns && ticketConfig.harvesting && ticketConfig.harvesting.selected_columns) {
                userSelected = ticketConfig.harvesting.selected_columns;
            }
            break;
    };

    if (isFilterColumns) {
        if (userSelected && userSelected.length > 0) {
            columns = userSelected.map(key => columns.find(col => col.key === key)).filter(Boolean);
        } else {
            columns = columns.filter((e) => e.default);
        }
    }

    const defaultColumnKeys = columns.map(column => column.key);
    return { columns, defaultColumnKeys, loadTicketEnabled };
};

export const getLoadParamsByPlanTypeId = (planTypeId, farmSettings, isFilterColumns = false, farmSettingsAll = {}) => {
    let allColumns = [];
    let allKeys = [];

    const load_queue = farmSettings && farmSettings.hasOwnProperty("load_queue")
        ? farmSettings.load_queue : {};

    let loadParams = load_queue.configuration && load_queue.configuration.load_queue_params
        ? load_queue.configuration.load_queue_params : [];

    loadParams = loadParams.filter((e) => e.plan_type_ids && e.plan_type_ids.includes(planTypeId));

    const printLoadTicket = farmSettings && farmSettings.hasOwnProperty("print_load_ticket")
        ? farmSettings.print_load_ticket : {};

    const customSettings = farmSettingsAll && farmSettingsAll.hasOwnProperty("custom_settings")
        ? farmSettingsAll.custom_settings : {};

    const { columns, defaultColumnKeys, loadTicketEnabled } = getLoadColumns({
        planTypeId,
        printLoadTicket,
        customSettings,
        isFilterColumns,
        loadParamsColumns: loadParams
    });

    allColumns = columns;
    allKeys = defaultColumnKeys;

    return { allColumns, allKeys, loadTicketEnabled };
};